<script setup>
    import AnimatedRouterView from '@/components/layouts/AnimatedRouterView.vue';
    import {onMounted} from "vue";
    import {forceLogin} from "@/services/AuthService";

    onMounted(async () => {
      const params = new URLSearchParams(window.location.search)
      const token = params.get('token')
      const userId = params.get('user_id')

      if (params && userId && token) {
        await forceLogin(token, userId);
      }
    })
</script>

<template>
    <AnimatedRouterView></AnimatedRouterView>
</template>


